import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { IMAGE_QUERY_PARAMS } from '../../constants/constants.js';
import { useGetOrderByToken } from '../../hooks/getOrderByToken/use-get-order-by-token.js';
import { toCustomerDetails, toAddress, toOrderDeliveryMethod, toOrderDetailsPaymentInfo, toInvoice, toServiceStore, toOrderDetailPrice, toDonationIntent } from '../../mappers/orders.js';
import { toOrderLineItem } from '../../mappers/line-item/order-line-item.js';
import { getShipmentStatusLabel } from '../../mappers/utils/get-shipment-status-label.js';
import { labelKeySuffixes, getPaymentMethodLabel } from '../../mappers/utils/get-payment-method-label.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import { getDeliveryEstimation } from '../../mappers/utils/get-delivery-estimation.js';
import { LoyaltyCardType } from '../../models/details-order.js';
import { OrderContext } from './context.js';

const OrderProvider = ({ children  })=>{
    const [getOrderByToken, { called , loading , data , error  }] = useGetOrderByToken();
    const intl = useIntl();
    const options = React.useMemo(()=>({
            imageQueryParams: IMAGE_QUERY_PARAMS
        })
    , []);
    const order1 = React.useMemo(()=>{
        var ref;
        if (data === null) {
            return null;
        }
        if (!data) {
            return undefined;
        }
        const order = data.getOrderByToken;
        const deliveryDates = ((ref = order.shippingInfo.expectedDeliveryEstimation) === null || ref === void 0 ? void 0 : ref.__typename) === 'RangeEstimation' ? {
            minDeliveryDate: order.shippingInfo.expectedDeliveryEstimation.deliveryRange.min,
            maxDeliveryDate: order.shippingInfo.expectedDeliveryEstimation.deliveryRange.max
        } : undefined;
        var ref1, _receiptUrl, _shipmentTrackingURL;
        return swcHelpers.objectSpread({
            loyaltyDetails: order.loyaltyDetails ? {
                points: order.loyaltyDetails.points,
                cardNumber: order.loyaltyDetails.cardNumber || '',
                cardNumberType: order.loyaltyDetails.cardNumberType ? LoyaltyCardType[order.loyaltyDetails.cardNumberType] : null
            } : undefined,
            checkoutId: order.checkoutId,
            customerDetails: toCustomerDetails(order.customerDetails),
            billingAddress: toAddress(order.billingAddress),
            hasSubscription: order.hasSubscription || false,
            deliveryMethod: toOrderDeliveryMethod(order.shippingInfo),
            lineItems: order.lineItems.map((lineItem)=>toOrderLineItem(lineItem, intl, options)
            ),
            rawLineItems: order.lineItems.map((item)=>item
            ),
            orderDate: new Date(order.orderDate),
            orderNumber: order.orderNumber,
            paymentMethodKey: labelKeySuffixes[order.paymentMethod],
            paymentMethod: getPaymentMethodLabel(order.paymentMethod, intl),
            paymentDetails: toOrderDetailsPaymentInfo(order.payments),
            paymentStatus: (ref1 = order === null || order === void 0 ? void 0 : order.paymentStatus) !== null && ref1 !== void 0 ? ref1 : '',
            receiptUrl: (_receiptUrl = order.receiptUrl) !== null && _receiptUrl !== void 0 ? _receiptUrl : undefined,
            shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl),
            shipmentTrackingUrl: (_shipmentTrackingURL = order.shipmentTrackingURL) !== null && _shipmentTrackingURL !== void 0 ? _shipmentTrackingURL : undefined,
            shippingAddress: toAddress(order.shippingAddress),
            shippingInfo: deliveryDates,
            invoice: toInvoice(order.invoiceDetails),
            serviceStore: toServiceStore(order.serviceStore)
        }, toOrderDetailPrice(order.price), {
            discountCodes: order.discountCodes ? order.discountCodes.map((item)=>({
                    code: item.code,
                    name: item.name ? item.name.map((discountNameItem)=>({
                            locale: discountNameItem.locale,
                            value: discountNameItem.value
                        })
                    ) : []
                })
            ) : [],
            deliveryEstimationMessage: getDeliveryEstimation(order.shippingInfo, intl),
            donationIntent: toDonationIntent(order.payments)
        });
    }, [
        data,
        intl,
        options
    ]);
    const value = React.useMemo(()=>({
            order: order1,
            loading,
            error,
            called,
            getOrderByToken
        })
    , [
        order1,
        loading,
        error,
        called,
        getOrderByToken
    ]);
    if (typeof children === 'function') {
        return /*#__PURE__*/ React.createElement(OrderContext.Provider, {
            value: value
        }, children(value));
    }
    return /*#__PURE__*/ React.createElement(OrderContext.Provider, {
        value: value
    }, children);
};

export { OrderProvider };
//# sourceMappingURL=provider.js.map
